import React, { Component } from 'react'
import ChannelChart from './ChannelChart'
import CursorLineLayer from './CursorLineLayer'
import InteractiveLayer from './InteractiveLayer'
import GridLayer from './GridLayer'
import EventsLayer from './EventsLayer'
import SWLayer from './SWLayer'
import SnoreLayer from './SnoreLayer'
import LabelLayer from './LabelLayer'
import StageLayer from './StageLayer'
import EventInfoWindow from './EventInfoWindow'
import MemoLayer, { MEMO_BOX_WIDTH } from './MemoLayer'
import MemoDialog from './MemoDialog'
import FixedAnnotationLayer from './FixedAnnotationLayer'
import { linearScale } from './functions/LinearScale'
//import { defaultParameters } from './functions/DefaultParameters'
import clamp from './functions/Clamp'
import { computeAmplitude } from './functions/computeAmplitude'

const LEFT_BUTTON_NOTHING = -1
const LEFT_BUTTON_MOVE_CURSOR = 0
const LEFT_BUTTON_CLICK_EVENT = 1
const LEFT_BUTTON_DRAG_EVENT = 2

class MultichannelChart extends Component {
	constructor(props) {
		super(props)

		// setup index to convert channelId to channelNum
		this.channelIdToChannelNum = {}
		for (let i = 0; i < props.data.length; i++) {
			this.channelIdToChannelNum[props.data[i].channelId] = i
		}
		//console.log(this.channelIdToChannelNum)
		this.verticalPositionToChannelId = this.verticalPositionToChannelId.bind(this)
		this.onRightDragStart = this.onRightDragStart.bind(this)
		this.onRightDrag = this.onRightDrag.bind(this)
		this.onRightDragEnd = this.onRightDragEnd.bind(this)
		this.startAutoPageTurn = this.startAutoPageTurn.bind(this)
		this.stopAutoPageTurn = this.stopAutoPageTurn.bind(this)
		this.autoPageTurnTimer = null
		this.rightDraggingLocked = false // 翻頁後鎖定 rightDragging，直到滑鼠往左移才解鎖
		this.onLeftDragStart = this.onLeftDragStart.bind(this)
		this.onLeftDrag = this.onLeftDrag.bind(this)
		this.onLeftDragEnd = this.onLeftDragEnd.bind(this)
		this.dragCancel = this.dragCancel.bind(this)
		this.onMouseMove = this.onMouseMove.bind(this)
		this.onMouseScroll = this.onMouseScroll.bind(this)

		this.secondToXPosition = this.secondToXPosition.bind(this)
		this.valueToYPosition = this.valueToYPosition.bind(this)

		this.getChannelCenterline = this.getChannelCenterline.bind(this)

		this.gravityToXPosition = this.gravityToXPosition.bind(this)

		this.proportionToXPosition = this.proportionToXPosition.bind(this)
		this.proportionToAbsoluteSecond = this.proportionToAbsoluteSecond.bind(this)
		this.absoluteSecondToXPosition = this.absoluteSecondToXPosition.bind(this)

		this.isMouseAtAnyEventBoundary = this.isMouseAtAnyEventBoundary.bind(this)
		this.getEventWhoseBoundaryIsMouseAt = this.getEventWhoseBoundaryIsMouseAt.bind(this)
		this.getEventWhichIsMouseOn = this.getEventWhichIsMouseOn.bind(this)

		this.onDoubleClick = this.onDoubleClick.bind(this)
		this.saveMemo = this.saveMemo.bind(this)
		this.deleteMemoFromDialog = this.deleteMemoFromDialog.bind(this)
		this.closeMemoDialog = this.closeMemoDialog.bind(this)

		this.state = {
			// 以下單位皆為proportion
			rightDraggingStart: null, // 右鍵拖曳起始點
			rightDraggingStartAbsSecond: null, // 右鍵拖曳起始點（絕對秒數，跨頁用）
			rightDragging: null, // 右鍵拖曳中位置
			rightDraggingChannel: null, // 右鍵拖曳中channel
			leftDraggingStart: null, // 左鍵拖曳起始點
			leftDragging: null, // 左鍵拖曳中位置
			leftDraggingChannel: null, // 左鍵拖曳中channel

			leftDraggingType: LEFT_BUTTON_NOTHING, // 左鍵動作種類
			editingEvent: null,

			eventInfoWindowEventId: null,
			eventInfoWindowVisible: false,

			memoDialogVisible: false,
			memoDialogMode: 'add',
			memoDialogSecond: 0,
			memoDialogMemoId: null,
		}
	}
	componentDidMount() {
		//關閉瀏覽器默認右键事件
		document.oncontextmenu = function (e) {
			e = e || window.event;
			return false;
		};
	}
	componentDidUpdate(prevProps) {
		// 翻頁後重新計算右鍵拖曳起始點的 proportion，並鎖定終點在頁面最前端
		if (prevProps.secondFrom !== this.props.secondFrom &&
			this.state.rightDraggingStartAbsSecond !== null) {
			let absSecToProportion = linearScale(this.props.secondFrom, this.props.secondTo, 0, 1)
			this.rightDraggingLocked = true // 必須先設再 setState，避免 mousemove 插隊
			this.setState({
				rightDraggingStart: absSecToProportion(this.state.rightDraggingStartAbsSecond),
				rightDragging: 0,
			})
			this.startAutoPageTurn()
		}
	}
	startAutoPageTurn() {
		if (this.autoPageTurnTimer !== null) return
		if (!this.props.pageDown) return
		// 用 setTimeout 而非 setInterval：每次翻頁後需重新等待 2000ms，使用者必須持續停在邊緣才會繼續翻頁
		this.autoPageTurnTimer = setTimeout(() => {
			this.autoPageTurnTimer = null
			if (this.state.rightDraggingStart === null) return
			this.props.pageDown()
		}, 1500)
	}
	stopAutoPageTurn() {
		if (this.autoPageTurnTimer !== null) {
			clearTimeout(this.autoPageTurnTimer)
			this.autoPageTurnTimer = null
		}
	}
	componentWillUnmount() {
		this.stopAutoPageTurn()
	}
	isMouseAtAnyEventBoundary(channelId, mouseXPosition) {
		return this.getEventWhoseBoundaryIsMouseAt(channelId, mouseXPosition) !== null
	}
	getEventWhoseBoundaryIsMouseAt(channelId, mouseXPosition) {
		//let absoluteSecondToXPosition = linearScale(this.props.secondFrom, this.props.secondTo, this.props.leftSpace, this.props.width - this.props.rightSpace)
		let nearestDistance = 5
		let nearestEvent = null
		for (let i = 0; i < this.props.events.length; i++) {
			let event = this.props.events[i]
			if (event.channelId === channelId) {
				if (event.secondFrom >= this.props.secondFrom) {
					let eventLeftBoundaryXPosition = this.absoluteSecondToXPosition(event.secondFrom)
					let distance = Math.abs(eventLeftBoundaryXPosition - mouseXPosition)
					if (distance <= nearestDistance) {
						nearestDistance = distance
						nearestEvent = Object.assign({
							nearestBoundary: 'left'
						}, event)
					}
				}
				if (event.secondTo <= this.props.secondTo) {
					let eventRightBoundaryXPosition = this.absoluteSecondToXPosition(event.secondTo)
					let distance = Math.abs(eventRightBoundaryXPosition - mouseXPosition)
					if (distance <= nearestDistance) {
						nearestDistance = distance
						nearestEvent = Object.assign({
							nearestBoundary: 'right'
						}, event)
					}
				}
			}
		}
		return nearestEvent
	}
	getEventWhichIsMouseOn(channelId, mouseXPosition) {
		let xPositionToAbsoluteSecond = linearScale(this.props.leftSpace, this.props.width - this.props.rightSpace, this.props.secondFrom, this.props.secondTo)
		let mouseAbsoluteSecond = xPositionToAbsoluteSecond(mouseXPosition)
		for (let i = 0; i < this.props.events.length; i++) {
			let event = this.props.events[i]
			if (event.channelId === channelId) {
				if (event.secondFrom < mouseAbsoluteSecond && mouseAbsoluteSecond < event.secondTo) {
					return Object.assign({}, event)
				}
			}
		}
		return null
	}
	// function for InteractiveLayer to get channel ID
	verticalPositionToChannelId(y) {
		const channelHeight = (this.props.height - this.props.topSpace - this.props.bottomSpace + this.props.interspace) / this.props.data.length - this.props.interspace
		const halfChannelHeight = channelHeight / 2
		let channelCenterPosition = this.props.topSpace + halfChannelHeight
		for (let i = 0; i < this.props.data.length; i++) {
			if (Math.abs(y - channelCenterPosition) <= halfChannelHeight) {
				return this.props.data[i].channelId
			}
			channelCenterPosition += channelHeight + this.props.interspace
		}
		return -1
	}
	// functions for InteractiveLayer callback
	onRightDragStart(channelId, proportion) {
		// console.log("right drag start", channelId, proportion)
		if (proportion > 1 || proportion < 0) return
		// 確認這個channel上可不可以標事件
		if (channelId === -1) return
		let channelNum = this.channelIdToChannelNum[channelId]
		//console.log('draggable', this.props.data[channelNum].draggable)
		if (!this.props.data[channelNum].draggable) return
		this.setState({
			rightDraggingStart: proportion,
			rightDraggingStartAbsSecond: this.proportionToAbsoluteSecond(proportion),
			rightDraggingChannel: channelId,
		})
	}
	onRightDrag(proportion) {
		//console.log("right drag", proportion)
		proportion = clamp(0, proportion, 1)
		if (this.state.rightDraggingStart === null) return // 如果在標籤上拖動，直接返回
		//console.log(proportion)

		if (this.rightDraggingLocked) {
			// 翻頁後鎖定：滑鼠必須往左移到 < 0.95 才解鎖並開始正常更新
			if (proportion < 0.95) {
				this.rightDraggingLocked = false
				this.setState({ rightDragging: proportion })
			}
			// 若仍在右邊緣（>= 0.95），不更新 rightDragging，讓它維持在 0（頁面起始點）
		} else {
			this.setState({ rightDragging: proportion })
		}

		// 靠近右邊界時自動翻頁
		if (proportion >= 0.98 && this.props.pageDown) {
			this.startAutoPageTurn()
		} else {
			this.stopAutoPageTurn()
		}
	}
	onRightDragEnd(proportion) {
		// console.log("right drag end", proportion)
		this.stopAutoPageTurn()
		// 若還在鎖定狀態放開滑鼠，事件結束於頁面起始（即上一頁結尾），不延伸到新頁面
		if (this.rightDraggingLocked) {
			proportion = 0
			this.rightDraggingLocked = false
		}
		proportion = clamp(0, proportion, 1)
		//console.log(this.state.rightDraggingChannel)
		if (this.state.rightDraggingChannel === -1 ||
			this.state.rightDraggingStart === null) { // 如果在間隙拖動
			//console.log('無效事件')
		} else if (this.state.rightDragging === null) { // 如果只有點擊，沒有拖動
			// // 新增一個 3 秒的事件
			// let absoluteSecondFrom = this.proportionToAbsoluteSecond(this.state.rightDraggingStart)
			// let absoluteSecondTo = absoluteSecondFrom + 3
			// if (this.props.editable) this.props.addEvent(this.state.rightDraggingChannel, absoluteSecondFrom, absoluteSecondTo, this.props.getChannelEvents(this.state.rightDraggingChannel)[0], false)
		} else { // 如果有拖動（包含跨頁情況）
			let absoluteSecondStart = this.state.rightDraggingStartAbsSecond !== null
				? this.state.rightDraggingStartAbsSecond
				: this.proportionToAbsoluteSecond(this.state.rightDraggingStart)
			let absoluteSecondEnd = this.proportionToAbsoluteSecond(proportion)
			let absoluteSecondFrom = Math.min(absoluteSecondStart, absoluteSecondEnd)
			let absoluteSecondTo = Math.max(absoluteSecondStart, absoluteSecondEnd)
			if (absoluteSecondFrom < absoluteSecondTo) { // 有效事件
				if (this.props.editable) {
					const amplitude = computeAmplitude(this.state.rightDraggingChannel, absoluteSecondFrom, absoluteSecondTo, this.props.secondFrom, this.props.secondTo, this.props.data, this.props.preData, this.props.nextData)
					this.props.addEvent(this.state.rightDraggingChannel, absoluteSecondFrom, absoluteSecondTo, this.props.getChannelEvents(this.state.rightDraggingChannel)[0], false, amplitude)
				}
			}
		}


		// 在新增完事件後開啟info window
		let event = this.getEventWhichIsMouseOn(this.state.rightDraggingChannel, this.proportionToXPosition(proportion) - 5)
		const draggableChannels = [1, 2, 3, 4, 5, 6, 16, 17, 18];
		if (event === null) event = this.getEventWhichIsMouseOn(this.state.rightDraggingChannel, this.proportionToXPosition(proportion) + 5)
		if (event !== null && !draggableChannels.includes(this.state.rightDraggingChannel)) {
			//console.log('popup window')
			//let eventId = event.eventId
			this.setState({
				eventInfoWindowEventId: event.eventId,
				eventInfoWindowVisible: true,
				rightDragging: null,
				rightDraggingChannel: null,
				rightDraggingStart: null,
				rightDraggingStartAbsSecond: null,
			})
		}
		else {
			this.setState({
				rightDragging: null,
				rightDraggingChannel: null,
				rightDraggingStart: null,
				rightDraggingStartAbsSecond: null,
			})
		}
	}
	onLeftDragStart(channelId, proportion) {
		//console.log("left drag start", channelId, proportion)
		let mouseXPosition = this.proportionToXPosition(proportion)
		//console.log('mouseXPosition', mouseXPosition)
		let event = this.getEventWhoseBoundaryIsMouseAt(channelId, mouseXPosition)
		if (event === null) { // 可能是移動游標或是點擊事件
			if (proportion < 0 || proportion > 1) return
			event = this.getEventWhichIsMouseOn(channelId, mouseXPosition)
			if (event === null) { // 移動游標
				this.setState({
					leftDraggingStart: proportion,
					leftDraggingType: LEFT_BUTTON_MOVE_CURSOR,
					leftDraggingChannel: channelId
				})
				this.props.moveCursor(this.proportionToAbsoluteSecond(proportion)) //更換紅線的位置
			} else { // 點擊事件
				this.setState({
					leftDraggingStart: proportion,
					leftDraggingType: LEFT_BUTTON_CLICK_EVENT,
					leftDraggingChannel: channelId,
					editingEvent: event
				})
			}
		} else { // 拖曳事件
			let absoluteSecondToProportion = linearScale(this.props.secondFrom, this.props.secondTo, 0, 1)
			let dragStartProportion = absoluteSecondToProportion( // 將起始位置設為事件邊緣
				event.nearestBoundary === 'left' ?
					event.secondFrom :
					event.nearestBoundary === 'right' ?
						event.secondTo : null)
			this.setState({
				leftDraggingStart: dragStartProportion,
				leftDraggingType: LEFT_BUTTON_DRAG_EVENT,
				leftDraggingChannel: channelId,
				editingEvent: event
			})
		}
	}
	onLeftDrag(proportion) {
		//console.log("left drag", proportion)
		proportion = clamp(0, proportion, 1)
		this.setState({
			leftDragging: proportion
		})
		if (this.state.leftDraggingType === LEFT_BUTTON_MOVE_CURSOR) {
			this.props.moveCursor(this.proportionToAbsoluteSecond(proportion))
		}
	}
	onLeftDragEnd(proportion) {
		//console.log("left drag end", proportion)
		proportion = clamp(0, proportion, 1)
		if (this.state.leftDraggingType === LEFT_BUTTON_MOVE_CURSOR) {
			this.props.moveCursor(this.proportionToAbsoluteSecond(proportion))
		} else if (this.state.leftDraggingType === LEFT_BUTTON_CLICK_EVENT) {
			let event = this.getEventWhichIsMouseOn(this.state.leftDraggingChannel, this.proportionToXPosition(proportion))
			if (event !== null && event.eventId === this.state.editingEvent.eventId) {
				//console.log('popup window')
				//let eventId = event.eventId
				this.setState({
					eventInfoWindowEventId: event.eventId,
					eventInfoWindowVisible: true
				})
			}
		} else if (this.state.leftDraggingType === LEFT_BUTTON_DRAG_EVENT) {
			if (this.state.leftDragging !== null) {
				let event = this.state.editingEvent
				let newBoundary1Second = this.proportionToAbsoluteSecond(proportion)
				let newBoundary2Second =
					event.nearestBoundary === 'left' ?
						event.secondTo :
						event.nearestBoundary === 'right' ?
							event.secondFrom : null
				this.props.deleteEvent(event.eventId)
				let secondFrom = Math.min(newBoundary1Second, newBoundary2Second)
				let secondTo = Math.max(newBoundary1Second, newBoundary2Second)
				if (this.props.editable) {
					const amplitude = computeAmplitude(this.state.leftDraggingChannel, secondFrom, secondTo, this.props.secondFrom, this.props.secondTo, this.props.data, this.props.preData, this.props.nextData)
					this.props.addEvent(this.state.leftDraggingChannel, secondFrom, secondTo, event.type, true, amplitude)
				}
			}
		}
		//let event = this.getEventWhichIsMouseOn(this.state.leftDraggingChannel, this.proportionToXPosition(proportion) + 5)
		//console.log(event)
		// if (event !== null && this.state.leftDraggingChannel !== 2) {
		// 	//console.log('popup window')
		// 	//let eventId = event.eventId
		// 	/*
		// 	this.setState({
		// 		eventInfoWindowEventId: event.eventId,
		// 		eventInfoWindowVisible: true
		// 	})
		// 	*/
		// }
		this.setState({
			leftDraggingStart: null,
			leftDragging: null,
			leftDraggingChannel: null,
			leftDraggingType: LEFT_BUTTON_NOTHING,
			editingEvent: null
		})
	}
	dragCancel() {
		//console.log("drag cancel")
		this.stopAutoPageTurn()
		this.rightDraggingLocked = false
		this.setState({
			rightDragging: null,
			rightDraggingChannel: null,
			rightDraggingStart: null,
			rightDraggingStartAbsSecond: null,
			leftDraggingStart: null,
			leftDraggingChannel: null,
			leftDragging: null,
			leftDraggingType: LEFT_BUTTON_NOTHING,
			editingEvent: null
		})
	}
	onMouseMove(channelId, proportion) {
		//console.log("mouse move", channelId, proportion)
		let mouseXPosition = this.proportionToXPosition(proportion)
		if (this.props.editable) {
			if (this.isMouseAtAnyEventBoundary(channelId, mouseXPosition)) {
				document.body.style.cursor = 'ew-resize'
			} else {
				document.body.style.cursor = 'auto'
			}
		}
	}
	onMouseScroll(channelId, up) {
		//console.log("mouse scroll", channelId, up)
		let zoomable = false
		let i = 0
		for (i = 0; i < this.props.data.length; i++) { // 先查出那個 channel 是否可以縮放
			if (this.props.data[i].channelId === channelId) {
				zoomable = this.props.data[i].zoomable
				break
			}
		}
		if (zoomable) { // 如果可以縮放
			this.props.zoomChannel(channelId, up)
			let nextScales = Object.assign({}, this.state.scales)
			if (nextScales[channelId] === undefined) {
				nextScales[channelId] = 0
			}
			nextScales[channelId] += up ? -1 : 1
			nextScales[channelId] = clamp(this.props.data[i].zoomMin, nextScales[channelId], this.props.data[i].zoomMax)
			this.setState({
				scales: nextScales
			})
		}
	}
	onDoubleClick(channelId, proportion) {
		const absoluteSecond = this.proportionToAbsoluteSecond(proportion)
		const clickX = this.proportionToXPosition(proportion)
		const memos = this.props.memos || []
		const nearbyMemo = memos.find(memo => {
			if (memo.second < this.props.secondFrom || memo.second > this.props.secondTo) return false
			const memoX = this.absoluteSecondToXPosition(memo.second)
			return clickX >= memoX - 5 && clickX <= memoX + MEMO_BOX_WIDTH + 5
		})
		if (nearbyMemo) {
			this.setState({
				memoDialogVisible: true,
				memoDialogMode: 'edit',
				memoDialogSecond: nearbyMemo.second,
				memoDialogMemoId: nearbyMemo.memoId,
			})
		} else {
			this.setState({
				memoDialogVisible: true,
				memoDialogMode: 'add',
				memoDialogSecond: absoluteSecond,
				memoDialogMemoId: null,
			})
		}
	}
	saveMemo(text) {
		if (this.state.memoDialogMode === 'add') {
			if (this.props.addMemo) this.props.addMemo(this.state.memoDialogSecond, text)
		} else {
			if (this.props.editMemo) this.props.editMemo(this.state.memoDialogMemoId, text)
		}
		this.setState({ memoDialogVisible: false, memoDialogMemoId: null })
	}
	deleteMemoFromDialog() {
		if (this.props.deleteMemo) this.props.deleteMemo(this.state.memoDialogMemoId)
		this.setState({ memoDialogVisible: false, memoDialogMemoId: null })
	}
	closeMemoDialog() {
		this.setState({ memoDialogVisible: false, memoDialogMemoId: null })
	}
	proportionToXPosition(proportion) {
		let transform = linearScale(0, 1, this.props.leftSpace, this.props.width - this.props.rightSpace)
		return transform(proportion)
	}
	proportionToAbsoluteSecond(proportion) {
		let transform = linearScale(0, 1, this.props.secondFrom, this.props.secondTo)
		return transform(proportion)
	}
	absoluteSecondToXPosition(absoluteSecond) {
		let transform = linearScale(this.props.secondFrom, this.props.secondTo, this.props.leftSpace, this.props.width - this.props.rightSpace)
		return transform(absoluteSecond)
	}
	// functions for GridLayer to get position
	secondToXPosition(sec) {
		let pageTimeInterval = this.props.secondTo - this.props.secondFrom
		//console.log(this.props.secondTo, this.props.secondFrom)
		let transformFunction = linearScale(0, pageTimeInterval, this.props.leftSpace, this.props.width - this.props.rightSpace)
		return transformFunction(sec)
	}
	valueToYPosition(channelId, value) {
		let channelNum = this.channelIdToChannelNum[channelId]
		//console.log(this.channelIdToChannelNum)
		//console.log('channelId', channelId)
		//console.log('channelNum', channelNum)
		const channelHeight = (this.props.height - this.props.topSpace - this.props.bottomSpace + this.props.interspace) / this.props.data.length - this.props.interspace
		let top = this.props.topSpace + (channelHeight + this.props.interspace) * channelNum
		let bottom = top + channelHeight
		let channelData = this.props.data[channelNum]
		let transformFunction = linearScale(channelData.max, channelData.min, top, bottom)
		return transformFunction(value)
	}
	// functions for EventsLayer
	getChannelCenterline(channelId) {
		let channelNum = this.channelIdToChannelNum[channelId]
		let data = this.props.data[channelNum]
		return this.valueToYPosition(channelId, (data.min + data.max) / 2)
	}
	// functions for LabelLayer
	gravityToXPosition(gravity) {
		return gravity === 'left' ? 0 : gravity === 'right' ? this.props.leftSpace : this.props.leftSpace / 2
	}
	render() {
		let charts = []
		charts.push(
			<GridLayer
				key="gridLayer"
				width={this.props.width}
				height={this.props.height}
				leftBoundary={this.props.leftSpace}
				rightBoundary={this.props.width - this.props.rightSpace}
				bottomBoundary={this.props.height - this.props.bottomSpace}
				topBoundary={this.props.topSpace}
				secondToXPosition={this.secondToXPosition}
				valueToYPosition={this.valueToYPosition}
				verticalLines={this.props.verticalLines}
				horizontalLines={this.props.horizontalLines}
				isZoomed={(channelId) => {
					let channelNum = this.channelIdToChannelNum[channelId]
					return this.props.data[channelNum].zoom !== 0
				}}
			/>
		)
		let channelHeight = (this.props.height - this.props.topSpace - this.props.bottomSpace + this.props.interspace) / this.props.data.length - this.props.interspace
		//console.log(channelHeight)

		if (this.props.loading === false) {
			for (let i = 0; i < this.props.data.length; i++) {
				// if (this.props.upordown===0 && i === 4) continue; // 把O1M2訊號變不見
				let fakei = i;
				if (this.props.upordown === 0 && fakei === 5) {
					fakei = 5
				}
				if (this.props.upordown === 0 && fakei === 3) {
					fakei = 3
				}
				if (this.props.upordown === 0 && fakei === 2) {
					fakei = 2
				}
				let x1 = this.props.data[i].min
				let x2 = this.props.data[i].max
				// console.log(`channelId: ${this.props.data[i].channelId}`)

				let y2 = this.props.topSpace + i * (this.props.interspace + channelHeight)
				let y1 = y2 + channelHeight

				let zoomScale = -1 * (this.props.data[fakei].zoom) + 1
				if (zoomScale <= 0) zoomScale = 1
				let yTransform
				if (this.props.data[fakei].fixedScale) {
					// 固定 Y 軸範圍的 channel（SpO2, Pulse, TcCO2, TcO2）：clamp 輸出到欄位邊界，防止溢出到其他欄位
					const baseTransform = linearScale(x1, x2, y1, y2)
					yTransform = (x) => {
						const y = baseTransform(x)
						return Math.min(Math.max(y, y2), y1)
					}
				}
				else {
					yTransform = linearScale(x1, x2, y1, y2)
				}
				let xTransform = linearScale(0, this.props.data[fakei].dataLength - 1, this.props.leftSpace, this.props.width - this.props.rightSpace)
				charts.push(
					<ChannelChart
						chartKey={
							this.props.data[fakei].channelId + ',' +
							this.props.width + ',' +
							this.props.height + ',' +
							this.props.secondFrom + ',' +
							this.props.secondTo + ',' +
							x1 + ',' + x2 + ',' + zoomScale
						}
						upordown={this.props.upordown}
						orkey={fakei}
						key={i}
						width={this.props.width}
						height={this.props.height}
						lineWidth={this.props.data[fakei].lineWidth}
						dataLength={this.props.data[fakei].dataLength}
						data={this.props.data[fakei].data}
						xTransform={xTransform}
						yTransform={yTransform}
						color={this.props.data[fakei].color}
						showLocalExtreme={this.props.data[fakei].showLocalExtreme}
						cid={this.props.data[fakei].channelId}
						{...(this.props.data[fakei].fixedScale ? { channelTop: y2, channelBottom: y1 } : {})}
					/>
				)
			}
		}
		let editingEvent = null
		if (this.state.rightDraggingStart !== null &&
			this.state.rightDragging !== null &&
			this.state.rightDraggingChannel !== -1) { // 如果右鍵拖曳而且有移動且不是在間隙拖動
			editingEvent = {}
			let proportionToRelativeSecond = linearScale(0, 1, 0, this.props.secondTo - this.props.secondFrom)
			editingEvent.channelId = this.state.rightDraggingChannel
			let rightDraggingStartRelativeSecond = proportionToRelativeSecond(this.state.rightDraggingStart)
			let rightDraggingRelativeSecond = proportionToRelativeSecond(this.state.rightDragging)
			editingEvent.secondFrom = Math.min(rightDraggingStartRelativeSecond, rightDraggingRelativeSecond)
			editingEvent.secondTo = Math.max(rightDraggingStartRelativeSecond, rightDraggingRelativeSecond)
			//console.log(editingEvent)
		}

		if (this.state.leftDraggingType === LEFT_BUTTON_DRAG_EVENT &&
			this.state.leftDragging !== null) { // 如果正在拖曳事件且開始拖曳
			editingEvent = {}
			let oneBoundary = this.proportionToAbsoluteSecond(this.state.leftDragging) // 顯示的其中一個拖曳框邊界
			oneBoundary -= this.props.secondFrom
			//console.log('one boundary', oneBoundary)
			let theOtherBoundary = null // 顯示的另一個拖曳框邊界
			if (this.state.editingEvent.nearestBoundary === 'left') { // 如果拖曳左邊界
				theOtherBoundary = clamp(this.props.secondFrom, this.state.editingEvent.secondTo, this.props.secondTo) // 超過頁面的部份截斷
			} else { // 如果拖曳右邊界
				theOtherBoundary = clamp(this.props.secondFrom, this.state.editingEvent.secondFrom, this.props.secondTo) // 超過頁面的部份截斷
			}
			theOtherBoundary -= this.props.secondFrom // 轉成相對秒數
			//console.log('the other boundary', theOtherBoundary)
			editingEvent.secondFrom = Math.min(oneBoundary, theOtherBoundary)
			editingEvent.secondTo = Math.max(oneBoundary, theOtherBoundary)
			editingEvent.channelId = this.state.leftDraggingChannel
			//console.log(editingEvent)
		}
		//console.log(this.props.events)
		charts.push(
			<EventsLayer
				key="eventsLayer"
				width={this.props.width}
				height={this.props.height}
				getChannelCenterline={this.getChannelCenterline}
				secondToXPosition={this.secondToXPosition}
				eventHeight={channelHeight}
				interval={this.props.secondTo - this.props.secondFrom}
				events={this.props.events.map((event, index) => {
					let derivedEvent = {
						channelId: event.channelId,
						secondFrom: event.secondFrom - this.props.secondFrom,
						secondTo: event.secondTo - this.props.secondFrom,
						type: event.type,
						color: event.color,
						eventId: event.eventId
					}
					return derivedEvent
				})}
				editingEvent={this.props.editable ? editingEvent : null}
			/>
		)
		if (this.props.swEvents) {
			charts.push(
				<SWLayer
					key="swLayer"
					width={this.props.width}
					height={this.props.height}
					getChannelCenterline={this.getChannelCenterline}
					secondToXPosition={this.secondToXPosition}
					eventHeight={channelHeight}
					interval={this.props.secondTo - this.props.secondFrom}
					events={this.props.swEvents.map((swEvent, index) => {
						let derivedEvent = {
							channelId: swEvent.channelId,
							secondFrom: swEvent.secondFrom - this.props.secondFrom,
							secondTo: swEvent.secondTo - this.props.secondFrom,
							type: swEvent.type,
							color: swEvent.color,
							eventId: swEvent.eventId
						}
						return derivedEvent
					})}
				/>
			)
		}
		if (this.props.snoreEvents) {
			charts.push(
				<SnoreLayer
					key="snoreLayer"
					width={this.props.width}
					height={this.props.height}
					getChannelCenterline={this.getChannelCenterline}
					secondToXPosition={this.secondToXPosition}
					eventHeight={channelHeight}
					interval={this.props.secondTo - this.props.secondFrom}
					events={this.props.snoreEvents.map((snoreEvent, index) => {
						let derivedEvent = {
							channelId: snoreEvent.channelId,
							secondFrom: snoreEvent.secondFrom - this.props.secondFrom,
							secondTo: snoreEvent.secondTo - this.props.secondFrom,
							type: snoreEvent.type,
							color: snoreEvent.color,
							eventId: snoreEvent.eventId
						}
						return derivedEvent
					})}
				/>
			)
		}
		charts.push(
			<StageLayer
				key={'stageLayer'}
				leftBoundary={this.props.leftSpace}
				rightBoundary={this.props.width - this.props.rightSpace}
				bottomBoundary={this.props.height - this.props.bottomSpace}
				topBoundary={this.props.topSpace}
				width={this.props.width}
				height={this.props.height}
				stages={this.props.stages}
			/>
		)
		if (this.props.memos && this.props.memos.length > 0) {
			charts.push(
				<MemoLayer
					key="memoLayer"
					memos={this.props.memos}
					secondFrom={this.props.secondFrom}
					secondTo={this.props.secondTo}
					secondToXPosition={this.secondToXPosition}
					height={this.props.height}
					width={this.props.width}
					topSpace={this.props.topSpace}
				/>
			)
		}
		charts.push(
			<FixedAnnotationLayer
				key="fixedAnnotationLayer"
				psgFileId={this.props.psgFileId}
				viewStartTimeSeconds={this.props.secondFrom}
				viewDurationSeconds={this.props.secondTo - this.props.secondFrom}
				leftBoundary={this.props.leftSpace}
				rightBoundary={this.props.width - this.props.rightSpace}
				topBoundary={this.props.topSpace}
				bottomBoundary={this.props.height - this.props.bottomSpace}
				width={this.props.width}
				height={this.props.height}
			/>
		)
		let absoluteSecondToProportion = linearScale(this.props.secondFrom, this.props.secondTo, 0, 1)
		charts.push(
			<CursorLineLayer
				key="cursorLineLayer"
				width={this.props.width}
				height={this.props.height}
				leftBoundary={this.props.leftSpace}
				rightBoundary={this.props.width - this.props.rightSpace}
				bottomBoundary={this.props.height - this.props.bottomSpace}
				topBoundary={this.props.topSpace}
				proportion={absoluteSecondToProportion(this.props.cursorSecond)}
				currentEpoch={this.props.currentEpoch} // 使用動態的 currentEpoch
				fileName={this.props.fileName}
				psgFileId={this.props.psgFileId}
				viewStartTimeSeconds={this.props.secondFrom}
				viewDurationSeconds={this.props.secondTo - this.props.secondFrom}
			/>
		)
		let horizontalPositionToProportion = linearScale(this.props.leftSpace, this.props.width - this.props.rightSpace, 0, 1)
		charts.push(
			<LabelLayer
				key="labelLayer"
				width={this.props.width}
				height={this.props.height}
				gravityToXPosition={this.gravityToXPosition}
				labels={this.props.labels}
				valueToYPosition={this.valueToYPosition}
			/>
		)
		charts.push(
			<InteractiveLayer
				key='interactiveLayer'
				horizontalPositionToProportion={horizontalPositionToProportion}
				verticalPositionToChannelId={this.verticalPositionToChannelId}
				onRightDragStart={this.onRightDragStart}
				onRightDrag={this.onRightDrag}
				onRightDragEnd={this.onRightDragEnd}
				onLeftDragStart={this.onLeftDragStart}
				onLeftDrag={this.onLeftDrag}
				onLeftDragEnd={this.onLeftDragEnd}
				dragCancel={this.dragCancel}
				onMouseMove={this.onMouseMove}
				onMouseScroll={this.onMouseScroll}
				onDoubleClick={this.onDoubleClick}
			/>
		)
		let showDesat = false
		if (this.state.eventInfoWindowEventId !== null) {
			let event = this.props.getEventInfo(this.state.eventInfoWindowEventId)
			showDesat = this.props.data[this.channelIdToChannelNum[event.channelId]].showDesat
		}
		//console.log(this.state.eventInfoWindowVisible)
		if (this.state.eventInfoWindowVisible) {
			charts.push(
				<EventInfoWindow
					key={'eventInfoWindow'}
					editable={this.props.editable}
					onSelected={this.props.setEventType}
					onCancel={() => {
						this.setState({
							eventInfoWindowVisible: false
						})
					}}
					onDelete={this.props.deleteEvent}
					getEventInfo={this.props.getEventInfo}
					getChannelEvents={this.props.getChannelEvents}
					eventId={this.state.eventInfoWindowEventId}
					data={this.props.data}
					preData={this.props.preData}
					nextData={this.props.nextData}
					secondFrom={this.props.secondFrom}
					secondTo={this.props.secondTo}
					visible={true}
					showDesat={showDesat}
					psgFileId={this.props.psgFileId}
				/>
			)
		}
		if (this.state.memoDialogVisible) {
			const editingMemo = this.props.memos && this.state.memoDialogMemoId != null
				? this.props.memos.find(m => m.memoId === this.state.memoDialogMemoId)
				: null
			charts.push(
				<MemoDialog
					key="memoDialog"
					visible={true}
					mode={this.state.memoDialogMode}
					initialText={editingMemo ? editingMemo.text : ''}
					onSave={this.saveMemo}
					onDelete={this.deleteMemoFromDialog}
					onCancel={this.closeMemoDialog}
				/>
			)
		}
		return charts
	}
}

MultichannelChart.defaultProps = {
	data: [/*{
		update: PropTypes.bool,
		lineWidth: PropTypes.number,
		dataLength: PropTypes.number,
		data: PropTypes.func.isRequired,
		max: ...,
		min: ...,
		color: PropTypes.string
	}*/],
	width: 800,
	height: 800,
	topSpace: 10,
	bottomSpace: 10,
	interspace: 5,
	leftSpace: 30,
	rightSpace: 10,
}

export default MultichannelChart
